











 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RemoveTeamMemberIntegrationAuthMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "teamMember",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "GitLabProviderRowTeamMember"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MattermostProviderRowTeamMember"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JiraServerProviderRowTeamMember"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AzureDevOpsProviderRowTeamMember"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MSTeamsProviderRowTeamMember"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "GcalProviderRowTeamMember"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RemoveTeamMemberIntegrationAuthSuccess",
  "abstractKey": null
};

(node ).hash = "2944d6b2d7db2bf4c42d97e666963bd2";

export default node;
